/**
 * Progressive-enhancement Add to Cart handler for product-list-item cards
 * (used by the Featured Collection section, etc).
 *
 * Falls back to a normal form POST to /cart/add (full page navigation to
 * cart) if fetch is unavailable or the request fails, so the button always
 * works even if this script errors out.
 */
(function () {
  'use strict';

  function setButtonState(button, state, text) {
    button.classList.remove('is-loading', 'is-added');
    if (state) {
      button.classList.add(state);
    }
    if (text) {
      button.textContent = text;
    }
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches('[data-product-list-item-add-to-cart-form]')) {
      return;
    }

    if (typeof window.fetch !== 'function') {
      // No fetch support: let the browser submit the form normally.
      return;
    }

    event.preventDefault();

    var button = form.querySelector('[data-product-list-item-add-to-cart-button]');
    var addText = button ? button.getAttribute('data-add-to-cart-text') : null;
    var addedText = button ? button.getAttribute('data-added-to-cart-text') : null;

    if (button) {
      if (button.disabled) {
        return;
      }
      button.disabled = true;
      setButtonState(button, 'is-loading', null);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
      },
      body: new URLSearchParams(new FormData(form)),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            throw new Error(errorData && errorData.description ? errorData.description : 'Unable to add to cart');
          });
        }
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:count', {
            detail: { count: cart.item_count },
          })
        );

        if (button) {
          setButtonState(button, 'is-added', addedText || button.textContent);
          setTimeout(function () {
            button.disabled = false;
            setButtonState(button, null, addText || button.textContent);
          }, 2000);
        }
      })
      .catch(function () {
        // If the AJAX request fails for any reason, fall back to a normal
        // form submission so the customer can still complete the add.
        if (button) {
          button.disabled = false;
          setButtonState(button, null, addText || button.textContent);
        }
        form.submit();
      });
  }

  document.addEventListener('submit', handleSubmit);
})();
